import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React, { useState } from 'react'

const Search = ({ onCloseHandler, queryString = '', style }) => {
  const [searchTerm, setSearchTerm] = useState(queryString)

  const handleChange = e => setSearchTerm(e.target.value)

  const onSearch = e => {
    e.preventDefault()
    window.location.replace(`/search?q=${searchTerm}`)
    onCloseHandler()
  }

  return (
    <div className='search-wrapper'>
      <form onSubmit={onSearch}>
        <input
          value={searchTerm}
          onChange={handleChange}
          type='search'
          name='search'
          placeholder='Search'
          autoComplete='off'
        />
        <button className='search' type='submit'>
          <FontAwesomeIcon icon={faSearch} size='lg' />
        </button>
      </form>
      <style jsx>{style}</style>
    </div>
  )
}

export default Search
